import React from 'react';
import {
    Grid, InputAdornment,
    TextField,
} from '@material-ui/core';
import {Key} from "react-feather";
import {useTranslation} from "react-i18next";



const ConnectorFormKey = ({ value, setKey, submitted, ...rest }) => {
    const {t} = useTranslation('connector');

    return (
        <Grid item xs={12}>
            <TextField
                fullWidth
                id="connector-key"
                label={t('label.api_key')}
                variant="outlined"
                value={ value }
                onChange={(event) => setKey(event.target.value)}
                InputProps={{
                    startAdornment: <InputAdornment style={{opacity: 0.5}} position="start"><Key /></InputAdornment>,
                }}
                disabled={submitted}
                required
            />
        </Grid>
    )
}

export default ConnectorFormKey;